import { render, staticRenderFns } from "./PairDetailDialog.vue?vue&type=template&id=be6c71f4&scoped=true"
import script from "./PairDetailDialog.vue?vue&type=script&lang=js"
export * from "./PairDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./PairDetailDialog.vue?vue&type=style&index=0&id=be6c71f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6c71f4",
  null
  
)

export default component.exports